/** Providers a checking / sort / recheck page can choose in its own dropdown. */
export const PAGE_PROVIDERS = [
  { value: 'local', label: 'LLM (local)' },
  { value: 'gemini', label: 'GT.1 (Gemini)' },
  { value: 'openai', label: 'CF.3 (gpt-5.4)' },
  { value: 'deepseek', label: 'DSv4' },
  { value: 'minimax', label: 'MiniMax' },
];

const ALLOWED = new Set(PAGE_PROVIDERS.map((p) => p.value));

export const CHECK_PROVIDER_KEY = 'checkApiProvider';
export const SORT_PROVIDER_KEY = 'sortApiProvider';

/** This page's saved choice. LLM (local) until the user picks another provider. */
export function readPageProvider(storageKey) {
  try {
    const own = localStorage.getItem(storageKey);
    if (ALLOWED.has(own)) return own;
  } catch (_) { /* ignore */ }
  return 'local';
}

export function writePageProvider(storageKey, value) {
  if (!ALLOWED.has(value)) return;
  try { localStorage.setItem(storageKey, value); } catch (_) { /* ignore */ }
}
